export const Bio = {
  name: "Balaji Sekar",
  roles: [
    "Full Stack Developer",
    "Android Developer",
    "Software Engineer",
    "Programmer",
  ],
  description:
    "I am a passionate Java Full Stack Developer, skilled in building scalable and efficient web applications using Java, Spring Boot, React.js, MySQL, and AWS Cloud services. With strong problem-solving skills and a positive mindset, I deliver high-quality solutions that align with business goals and drive success. Always eager to learn and adapt, I continuously explore new technologies to grow and contribute effectively to every project I undertake. My mission is to craft seamless, modern, and scalable full stack solutions powered by cloud technologies that create meaningful impact.",
  github: "https://github.com/Balaji-Rishi",
  resume:
    "https://drive.google.com/file/d/1zdMVg4L-YKwrOy9ddynxUFHwJ1Ndftxe/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/balaji268",
  // twitter: "https://twitter.com/",
  // insta: "https://www.instagram.com/",
  // facebook: "https://www.facebook.com/",
  hackerrank: "https://www.hackerrank.com/profile/balajikrish268",
  leetcode: "https://leetcode.com/u/Balaji_Sekar/",
  codechef: "https://www.codechef.com/users/swarm_queen_04",
  cridly: "https://www.credly.com/users/balaji-sekar-rishi",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
    
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "SASS",
        image:
          "https://rstudio.github.io/sass/reference/figures/logo.svg",
      },
      
      {
        name: "Tailwinds CSS",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAPFBMVEX////G6fxsyvk/v/g4vfhhyPmz4vuK1PoAtfckufgvu/hTxPn6/f+h2/tGwPjS7v255fxMwviT1/qn3vsZjXhWAAAAbElEQVR4AeWOCQqAMAwEq11r06b3//9qAwiI0QfowHINC2N+yLJabE53uycgUGTtF11CmDqLLVdZ57iJhSt9V+4cCQB5a1RGJgr9FrrW866GbmpoGylISlNC3RxnsbY+hLbX0GSJIKE6zOajHN4ZA8/fNs9XAAAAAElFTkSuQmCC",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Jquery",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACSElEQVR4AcXXA6wdQRSA4VPbtm3btm3bthXWtm3btm3bbk//JA+bzV7vS5N8a5zxjKjqfyWJu6y0S0SEg3jCmx+FhJgkQguEDOoAkiMJxGQKRkOCMoCkGIOwEJM3GGBXAJEhFg5gsoMiUSyxI4D6iA0xSQFFJYhJMHz141MA4zADYmEoFPkc3F8LxRBvA8gCRTGIhU1QVHVwvzDUTzlvArgNddKMjkIxEuLACqiflhAXEiOUsMkFxQOIAwehuAZx4gDUzx5URniIQTqMQ2EEEzaToLgEcWAZ1Hkx+fH7nsktnMMjvENnYxGchOIpQkEsdIX6uQpxITsm4Ay+Q/EWK5HWXAdeQPEXSSEW4kMNxkHcFAZhnVXCL1A/1SEOLIEatIb4Sti8h/qZD3EgJv5ADXpDvBQeZYXNTaifr86yCzWhJmuRCOKBJNiHosJmM9SgP8SJLlCT75iALBAnQqOt8T/il41q8A2RIU40wC+ohTOYjHaoh4boiuWGIhxkrAPJoCZbIC6kxlaoB96jolVXvAfqZQUriiV4C7XwA3vRAcEcjQV5oRaaQtwUAdlQHjVQFfkQ3d3heB3UQgdIEAiN8MYLkfARamEyxEYp0NEcgKAA1IGrKAfxUWncR26I487Gsa2oAvFQbEyEopmrWXEF/IQ6cR8TUQtpEM00T4yJzGiDlVA/7dydlqfFSaibPuA+buI+vkBN6nizLuiF91Af7EI6XxYmMdAPV6Ee2I2qdq8NC2EglmEvzuMyzmIrZqEpUkJcEVX9r/4B0dpZHaS3GLUAAAAASUVORK5CYII=",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Material UI",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOAAAADgCAMAAAAt85rTAAAAh1BMVEX///8Af/8Ad/8AfP8Aev/v+P8Adf8Ae/+Puv8Adv+72P8Ac/87k/8Agf/t9f/6/f/U5v+lyf/m8f+10//H3v/C2/9Tnf9npv/e7P+w0P9+s/9Il/+Ywf8rjP8xkP/A2f8ch//Q4/9zrf94r/+HuP+dxP8JhP9aoP/a6f9Mmv+py/+Tv/8Ab/9IeMWVAAAHEElEQVR4nO2d6XqqMBBAJUQodcG1tlqpS2tre9//+W6oWgWyTAiB4DfnNwaOZiQkk6HTQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQRAEQZCm2X5Pu3Wda/Y91zl8Mhoan3KY9AghD8btQJgeAhL5YMVtEgTRp+GXHx9Cj0EGU7N2AHz1g/RUXm8EOry76PnsaHqIjc76SrwTQQI7b1nO18vw+5Djx4SeDifvRuc9ns/KzhsszDu8kFcSXk7kRerfZLsmf9e1MTpx8ifoeSH5MWpLzOOBXE/jEVVYxX+/9q+h0alvBW2F4tcq8DwNwb/eWb0g6z79qkOxuwty55ALjtYke3i1gp7fW1R6V/ygNHcGqWA30zttCLJQjF6Nmrzl7UAK7csEx1FYOLxyQXYFhzejRi8854JPKbjjHW9BkN0VV89GzabE+3zwqQTnPd7hVgRZKO4MQzH3XwgRXBT7pzVBNkaiHwbtzjec4FMJ9rkXY0vQJBQnT4X/QhcF2eitVCjGS5meS4Kp4l47FMe+KPgcFNQPxVl+INKw4FolmIYi/ClcHnyOCrJ+eoSFYvweAZpzTzBVXAKeq79VweeuYBqKY0VL23UEa0pXMKxFkF3WeiZpZ/gpGJeZCw5qEmSjt6eJqJl3zlNARYJ0UZdgqsgPxRdg8JUR9CPht1q9IPs6ve9CE9sEGnwlBKm/NfLTFfS8KBeKw+IjeHWCoi5jU5Cd9POm0zwEGsGnKxj1zZ9K9QXT6cX38/c6HSjHZeUFqfdirFdO8DcUmeKsz52RqEawgt5pIMgukhwoKftZkeDq2mAVcyZGgiYIBZeXu001vfOXTf1+YsHJqctX1TvdE+zMCQ1pZb3TQcHO8Gex11oDbptg9aAgCrZX0De5Rco+7IYgJUk/LDPSPH14nRTXBZ0SjH4nfKHTSFnYjZp9OP4RPSa6IEjPuRvxkug+DvnBZWZjKjB0QfA60TN5gs8m/V795vpAfOR/0gHBcHdzyEyyEpYnO9H/zf+gA4I0m7umXE45k1+qeXRA8AARVC6InSiMktsjyELxqFLkLJe2SVC+KJ0GHyf3ZNoqQW5OzxlB9lDbBDvxjt9Pg/4X9/jWCfJTe8QZfC0UZH8cuanQMBDnYLZSMJvbyoJPkkXbUsFOd3EZvUXyPGhTwfnuacmPbjhlBDudUcIUfeIrZi/NBFm8hz7tmeRbdcoKsms/HhJlArSJYPfyj92TLSyrGZQUBGEgeL3n+k9G1+CmYHbUZHQNVgVfygk+Z8e9Zmkk7gnG+1w20Z0JFp8970qQN3twT4LchIY7Elxwj78fwck/7uH3Iyg4/H4EBbOMZoLcJlEQxvNKb2a7ZYLCnT13Iije2XMXgtL1DJHguDWCis0FbRdULmS0XFC9FFWrIP+7Li8I2NkjFuR/My4Jgnb2tFcwfodlkLZVEJySUatg2XnRAjPwzh5hLQsrgntuo9qCk0/45gJ/JWjEiuCQcrfTaApq7ewR1pP5sCHYeeYNqvQEtXb2UF84FW9HkHtn1hEc6ezs8SNJOrYtQc7YCi6otbNHtn/NpmDxBg0W1NrZI9+BaFUw/3wDFNTa2UND1R5Sq4Lpn/S1fQqpfTRKNHb2QPZCWBZkofi36hEAUvvn/zSCD7SP27Zgmq91mkYJ14CDBXlaPMgGtBfCvmAaigGlwQZSfwwsSAlwmb0OQfbHsVzCKnMBBf0AXJimHkEwMMFgBc8DeW2foF6dNn5BIIcFQ16KpZihYETrqqA8y4sDvw6Cs4KKLK8CbwPRoM9JQV+zSGK+/KHrgv5Ga49qV7hO46og0coRFKdKuyroJxrtyJPd3RQM4RVSLsPfdgn6R2AboA0nDgp6FDb8HMuDz2FBUB+FrNO4KugRZf1v2DqNs4Kqis/xErwr0bAMdXlUY1HZk8TYg08V11Smvoj6aUJUfF1nx6VH9QZFFQJ4HuQWX59oVGBLW2jKD/ZEHxY6mNY6TbQ2rMllAnBOJlv7Rm+dprqyOWUAz6pFyeVngJc/9G5LYzXEF7dmNI/zs73OImmuuFkzaJSDCnv9Rb/XluC7MNGJJz/UKDfAKzDYBJzC+1VQac0qQ0YlS8dJ9aSLpLVTrvifGNUiaQP86Px5KKBEtUjaBJWFIqxUchNoJVqI9Y5OBV+WqWcaijrlyhvhQbt00C00NNyLXAPDhV7poBvKvDKgCbTSLm7oVVqt0Spl7orOB18W3VA0e/FKE2gmr5m+OqcJ4APUakul1sgLKBTJ4bHpCy2PeoAaBtW9gKwJFKHYzuDLIhugRoIiUC1jKpigr+ONqjXBuyvaexFnExQGqHZfpdoE2ddt2H4ZbiNcB6hk0OhcvD1OoRhGD47OSJjDQrF3d8GXw+H5FgRBEARBEARBEARBEARBEARBEARBEARBEMZ/Z7h0SlKcxhsAAAAASUVORK5CYII=",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
    
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
          
      },
      {
        name: "Spring Boot",
        image: "https://dominickm.com/wp-content/uploads/2016/06/spring-boot-logo_full.png",
          
      },
      {
        name: "Spring",
        image:
          "https://www.vectorlogo.zone/logos/springio/springio-icon.svg",
      },
      {
        name: "Rest API",
        image:
          "https://www.vectorlogo.zone/logos/json/json-icon.svg",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
    
      {
        name: "Graph Ql",
        image: "https://www.vectorlogo.zone/logos/graphql/graphql-icon.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
     
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      // {
      //   name: "Kotlin",
      //   image:
      //     "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      // },
      {
        name: "XML",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSBMw6_RdwKQ9bDFfnKDX1iwMl4bVJEvd9PP53XuIw&s",
      },
      {
        name: "Gradle,",
        image:
          "https://gradle.org/images/gradle-knowledge-graph-logo.png",
      },
      {
        name: "Material Design",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToFgpv3NOy5HpVKFPb2_v6880b27DudUWfcA&s",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "AWS",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/amazonwebservices/amazonwebservices-original-wordmark.svg",
      },
      {
        name: "Maven",
        image:
          "https://logowik.com/content/uploads/images/maven-apache3537.jpg",
      },
     
      {
        name: "Git",
        image:
          "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
      },
      {
        name: "GitLab",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/144_Gitlab_logo_logos-512.png",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Bitbucket",
        image:
          "https://cdn.worldvectorlogo.com/logos/bitbucket-icon.svg",
      },
     
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Eclipse",
        image:
          "https://www.vectorlogo.zone/logos/eclipse/eclipse-icon.svg",

      },
      {
        name: "IntelliJ IDEA",
        image:"https://w7.pngwing.com/pngs/747/41/png-transparent-intellij-macos-bigsur-icon-thumbnail.png"
      },
      {
        name: "PyCharm",
        image:
          "https://e7.pngegg.com/pngimages/805/274/png-clipart-black-and-white-pc-logo-pycharm-logo-icons-logos-emojis-tech-companies.png",
      },
      {
        name: "Jira",
        image:
          "https://www.vectorlogo.zone/logos/atlassian_jira/atlassian_jira-icon.svg",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
      },
      {
        name: "Figma",
        image:
          "https://www.vectorlogo.zone/logos/figma/figma-icon.svg",
      },
      {
        name: "Adobe Illustrator",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/Adobe_Illustrator_CC_icon.svg/1200px-Adobe_Illustrator_CC_icon.svg.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://png.pngtree.com/templates/sm/20180519/sm_5b0022bcebeaa.jpg",
      },
      {
        name: "Photoshop",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Adobe_Photoshop_CC_icon.svg/1051px-Adobe_Photoshop_CC_icon.svg.png",
      },
      {
        name: "Canva",
        image:
          "https://www.vectorlogo.zone/logos/canva/canva-icon.svg",
      },

    
      
    ],
  },

  {
    title: "AI Tools",
    skills: [
      {
        name: "ChatGPT",
        image:
          "https://static.vecteezy.com/system/resources/previews/021/059/825/non_2x/chatgpt-logo-chat-gpt-icon-on-green-background-free-vector.jpg",
      },
      {
        name: "Gemini",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThr7qrIazsvZwJuw-uZCtLzIjaAyVW_ZrlEQ&s",
      },
      {
        name: "Deepseek",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQbkd4tSNbwqpd_xK7fICxDzkGHVEAi2YlPfw&s",
      },
      {
        name: "Github Copilot",
        image:
          "https://miro.medium.com/v2/resize:fit:700/0*oRRpMJ9XqkRnYLhW.png",
      },
      {
        name: "Amazon Q",
        image:
          "https://d1.awsstatic.com/getting-started-guides/learning/amazon-q/icon_amazon-q.a5c38564734b6e9f611e9599eb271142389313a4.png",
      }
      
    
      
    ],
  },
];

export const experiences = [
    {
    id: 0,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAIAAAD9b0jDAAABqUlEQVR4AbSUA4xdURRFb9jGqhVWQe3YSW3btt2Obdu2bdu2bWPPGesb61n7rUs2Pj6OKeZOxIdxTJy7FO0mG18AgOX7uRPBoxmkAAPAR4eTF8HxpkChHGtjLoLgeFM6xZ+zWIiYfUB6pnzJfoj2fKFb36TwrmLWsZAa/aHRHiyhxR5uDBlOqC0c6+2rOnKkQVmdf2hVT+adGPYsnqlk73Qv2VzWcn1wwBijoRj2R5890rfAaTVS3FCSWLVlfV9sbLt3kECmruU/gSEsZLR55k7kCsQrAegL8m+4fZNCoxkjZQDjI2PTJ9N41wjYUBRNmlVJABq2rRypqqp//Dx9zwkAcY+M3XZrf2Ga7GzsRdd+SmROKOmaaygeQ6U5GNqMbpJRw8EdzXJyZFqtZ5n7z4o0MYVfSvs6q2FaKbRzGATjMyjzlCkUwFigLZl2WFpShWZf+TJX6jnIkRIFK374Azi+AjD65uj0v0mzRNlU8H7KSdnnGbwUxg0/UH/CFOQoaD/lmttSjq9bqOwQBgYpIPVQDl1K9FlqYkChQe99zCRFTZcSNHeYJikAFxTXMNRiuEMAAAAASUVORK5CYII=",
    role: "Associate Software Engineer",
    company: "ThroughApps, Full-time",
    date: "Sep 2022 - Present (2 years 9 months)",
    desc: "As a Associate Software Developer, I'm working Java Full Stack Developer with expertise in designing, developing, and optimizing software solutions. Passionate about problem-solving, cloud computing, and full-stack development, with hands-on experience in Java, Spring Boot, React.js, and AWS. Adept at REST API development, database optimization, and system automation, with a proven track record of enhancing project efficiency.",
    skills: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "JQuery",
      "ReactJS",
      "Redux",
      "ajax",
      "Bootstrap",
      "Material UI",
      "Java",
      "Spring Boot",
      "Spring",
      "Rest API",
      "MySQL",
      "Postgresql",
      "MongoDB",
      "Git",
      "GitHub",
      "GitLab",
      "Bitbucket",
      "Netlify",
      "AWS",
      "Firebase",
      "Postman",
      "Figma",
      "Adobe Illustrator",
      "Adobe XD",
      "Photoshop",
      "Canva",
      "IntelliJ IDEA",
      "Eclipse",
      "VS Code",
      "Android Studio",
      "Gradle",
      "XML",
      "Material Design",
      "Jira",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/buckoid-917cf.appspot.com/o/Screenshot%20from%202023-05-28%2023-20-46.png?alt=media&token=5570f995-e8f4-4f12-bb2f-73bcf4b20730",
  },
 
  {
    id: 1,
    img: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAMAAABF0y+mAAAAPFBMVEVHcEy2tLK1srG2tbKYAJiZAJmYAJi0srC1s7GynK+ZAJmZAJmZAJm0srCZAJmZAJm2tLK0srC0s7C1s7HkPEQyAAAAFHRSTlMAWXIiNVgc/58Mi//59bneReC+hTCYA7QAAACDSURBVHgB5ZCFDcQwDAAvHDfl7D/rQyKr3qEnMCNvwflBAIgppQyE6XP4MqgCLK2tiyB1+rxqmyOmvbV2JNym+ZzXUO8QjxHL4R6O6wTEz8Quy3Ece6ZP2wvAk5l/PJ0YWNOkTqRr478+9/vpE5Ntuii6/C1y62EGPVtfgkUfZp75Ir7TpgfRTpdJ/QAAAABJRU5ErkJggg==",
    role: "Junior Software Developer",
    company: "VS Online Services,  Full-time",
    date: "Feb 2022 - Sep 2022 (8 months)",
    desc: "As a Junior Software Developer, I played a key role in developing a comprehensive e-commerce application with a focus on delivering a seamless and user-friendly shopping experience. My contributions included implementing essential features such as product catalog management, secure payment gateways, and efficient cart functionality, ensuring the platform was robust and scalable. Additionally, I developed the company’s official website, enabling the effective presentation of services and enhancing its online presence. By applying responsive development techniques, I ensured the website performed optimally across various devices, providing a consistent and professional user experience.",
    skills: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "JQuery",
      "Angular" ,
      "Bootstrap",
      "Front-End Development", 
      "GitHub",
      "Git",
      "MySQL",
      "Java",
      "Figma",
      "Amazon Web Services (AWS) ",

    ],
    // doc: "https://drive.google.com/file/d/1-YKkkOUBT8WX_8kfgBW_AY_qTqgrPd3X/view?usp=drive_link",
  },
];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQmUlTwOOUFrOU7C1use0llAObLBioeDCRqQ&s",
    school: "Madras university, Chennai - Tamil Nadu.",
    date: "Jun 2023 - Jun 2026",
    grade: "4-sem",
    desc: "I am currently pursuing a Bachelor's degree in Computer Applications at Madras University and have completed four semesters. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I'm also learning and working on exciting projects as part of a talented development team.",
    degree: "Bachelor Computer Applications",
  },
  {
    id: 1,
    img: "https://aktpolytechnic.com/wp-content/uploads/2024/09/logo.png",
    school: "AKT Memorial Polytechnic College, kallakurichi - Tamil Nadu.",
    date: "Aug 2019 - Jul 2021",
    grade: "95%",
    desc: "Completed a Diploma in Computer Engineering with a strong academic record, securing 95% and being the first rank holder in my CSE batch. Gained foundational knowledge in programming, computer hardware, networking, and software development. Participated in practical labs, technical workshops, and mini-projects that enhanced my problem-solving and coding skills.",
    degree: "Diploma of Education - Computer Engineering",
  },
  {
    id: 2,
    img: "https://pbs.twimg.com/profile_images/961107678893309957/43VEMGuP_400x400.jpg",
    school: "Government Higher Secondary School - Rishivandhiyam - Tamil Nadu.",
    date: "Jun 2017 - Apr 2019",
    grade: "67%",
    desc: "I completed my Class 12 higher secondary education at Government Higher Secondary School, Rishivandhiyam, Tamil Nadu, with a focus on Biology and Mathematics.",
    degree: "XII, Biology and Maths",
  },
  {
    id: 3,
    img: "https://pbs.twimg.com/profile_images/961107678893309957/43VEMGuP_400x400.jpg",
    school: "Government Higher Secondary School - Rishivandhiyam - Tamil Nadu.",
    date: "Jun 2016 - Mar 2017",
    grade: "92%",
    desc: "I completed my Class 10 education at Government Higher Secondary School, Rishivandhiyam, Tamil Nadu, where I studied Science with Mathematics. I secured 92% and ranked third in my class out of 350 students.",
    degree: "X, Science with Maths",
  },
];

export const projects = [
  {
    id: 0,
    title: "MyProject.AI — Smart Project Management Platform for Construction",
    date: "Feb 2025 - Mar 2025",
    description:
      "MyProject.AI is an AI-powered web platform designed to simplify and accelerate project management in the construction industry. It helps users to post, manage, and track home building and renovation projects with ease. Tailored for both clients and contractors, the platform provides real-time project visibility, seamless collaboration, and powerful search capabilities.",
    image:
      "https://github.com/Balaji-Rishi/mai_app/blob/main/MainPage.png?raw=true",
    tags: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "JQuery",
      "Bootstrap5",
      "React Js",
      "Redux",
      "AWS",
      "Iconic",
      "Material UI",
    ],
    category: "web app",
    github: "https://github.com/Balaji-Rishi/mai_app.git",
    webapp: "https://balaji-rishi.github.io/mai_app/",
  },

  {
    id: 1,
    title: "Vsonline Services",
    date: "Feb 2022 - May 2022",
    description:
      "Developed the frontend of a web application for vsOnlineServices, offering users services like bill payments, recharges, and ticket bookings. Built responsive and interactive user interfaces using React.js, ensuring a smooth experience across mobile, tablet, and desktop devices. Integrated APIs to display dynamic service data and handled user interactions effectively. Implemented Google Authentication to provide secure and easy login options. Focused on clean code practices, component reusability, and optimized UI performance. Collaborated with backend teams and followed agile methodologies for efficient feature delivery.",
    image:
      "https://github.com/Balaji-Rishi/vsonline-services/blob/main/MainPage.png?raw=true",
    tags: ["HTML5",
      "CSS3",
      "JavaScript",
      "JQuery",
      "Bootstrap5",
      "React Js",
      "Rest API",
      "Axios",
      "Redux",
      "Iconic",
      "Material UI"],
    category: "web app",
    github: "https://github.com/Balaji-Rishi/vsonline-services.git",
    webapp: "https://www.vsonlineservices.com/",
  },
  {
    id: 2 ,
    title: "vsecommerce.com",
    date: "Feb 2022 - Sep 2022",
    description:
      "vsEcommerce is a fully-featured, customizable e-commerce solution designed to help businesses build and grow their online stores with confidence. With vsEcommerce, you can create a professional, responsive store that reflects your brand identity, customize layouts and templates, track inventory and orders, and market your brand online — all in one platform. Our solution offers quick and quality answers to all e-commerce challenges, making it ideal for businesses looking for both speed and scalability. Built on a powerful SaaS-based API platform, vsEcommerce lets you expand your store's features as you grow, offering advanced capabilities like hyperlocal marketplace support, nearby service bookings, and on-demand video streaming sites. Whether you’re starting small or aiming big, vsEcommerce provides a solid foundation with customizable templates, mobile responsiveness, and a scalable architecture to help you succeed. Experience the power of vsEcommerce and take your business online with ease and efficiency.",
    image:
      "https://github.com/Balaji-Rishi/vsecommerce/blob/main/Mainpagesvsecom.png?raw=true",
    tags: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "JQuery",
      "Bootstrap5",
      "Rest API",
      "React Js",
      "Axios",
      "Redux",
      "Iconic",
      "Material UI",
    ],
    category: "web app",
    github: "https://github.com/Balaji-Rishi/vsonline-services.git",
    webapp: "https://vsecommerce.com/",
  },
  {
    id: 3,
    title: "Tictoks.in",
    date: "Sep 2022 - May 2025",
    description:
      "Tictoks is a next-generation Employee Monitoring Software designed to boost productivity by up to 30%, especially for remote and hybrid teams. With real-time monitoring, touchless facial recognition for attendance, and two-factor authentication, Tictoks ensures your team stays focused and your data remains fully secure. Our platform tracks employee attendance from check-in to check-out, monitors application and browser activity, and even captures automatic screenshots to prevent distractions. Stay on top of every keystroke, mouse click, and task progress with powerful analytics and active vs idle time reports. Whether you're managing a small team or a large workforce, Tictoks makes it easy to improve performance while storing your data securely in your own AWS server or Google Drive. Experience the future of employee monitoring with Tictoks — simple, secure, and built for results.",
    image:
      "https://github.com/Balaji-Rishi/tictoks.in/blob/main/Mainpagestictoks.in.png?raw=true",
    tags: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "JQuery",
      "Bootstrap5",
      "React Js",
      "Redux",
      "JQuery",
      "ajax",
      "Rest API",
      "Axios",
      "Material UI",
      "Google Drive API",
      "Java",
      "Spring Boot",
      "MySQL",
      "Rest API",
      "Git",
      "GitHub",

    ],
    category: "web app",
    github: "https://github.com/Balaji-Rishi/tictoks.in.git",
    webapp: "https://www.tictoks.in/",
  },
  {
    id: 4,
    title: "GarageApp",
    date: "Sep 2022 - May 2025",
    description:
      "GarageApp is an all-in-one business suite designed to help garage owners manage their operations smoothly. With GarageApp, you can get free customer bookings, accept online payments, create unlimited invoices and estimates, and track your expenses easily. It also helps you manage your inventory, vendors, and multiple garage locations from a single dashboard. Features like appointment booking, job card creation, quick estimations, and towing service booking make daily operations faster and more efficient. With advanced CRM tools, WhatsApp integration, and financial reporting, GarageApp transforms your car service business, helping you build customer trust and grow your revenue.",
    image:
      "https://github.com/Balaji-Rishi/GarageApp.in/blob/main/GarageAppmainpages.png?raw=true",
    tags: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "JQuery",
      "Bootstrap5",
      "React Js",
      "Redux",
      "JQuery",
      "ajax",
      "Rest API",
      "Axios",
      "Material UI",
      "Google Drive API",
      "Java",
      "Spring Boot",
      "MySQL",
      "Rest API",
      "Git",
      "GitHub",
    ],
    category: "web app",
    github: "https://github.com/Balaji-Rishi/GarageApp.in.git",
    webapp: "https://www.garageapp.in/",
  },

  {
    id: 5,
    title: "bhavanatech.com(Fast Fashion Solutions)",
    date: "Jan 2023 - Feb 2023",
    description:
      "Bhavana Tech is a leading technology solutions provider specializing in Retail & Fashion PLM (Product Lifecycle Management) technologies. With a strong focus on digital transformation and innovation, Bhavana Tech empowers global brands by offering a comprehensive suite of services, including strategic consulting, custom development, and managed services. The company is known for driving efficiency and creativity in the fashion and retail industry, helping clients streamline their product design and development lifecycle. Backed by a global network of experts, Bhavana Tech ensures access to best-in-class resources and scalable solutions tailored to meet the evolving needs of the market.",
    image:
      "https://github.com/Balaji-Rishi/bhavanatech.com/blob/main/mainpages.png?raw=true",
    tags: [
      "HTML5",
      "CSS3",
      "JavaScript",
      "JQuery",
      "Bootstrap5",
      "React Js",
      "Redux",
      "Iconic",
      "Material UI",
      "BlueHost",
      "WordPress",
    ],
    category: "web app",
    github: "https://github.com/Balaji-Rishi/GarageApp.in.git",
    webapp: "https://bhavanatech.com/",
  },

  {
    id: 6,
    title: "Through Face App",
    date: "Sep 2022 - Jan 2025",
    description:
      "Through Face App is an innovative Android application that leverages face recognition technology to offer a secure and seamless login experience. Built using Java, Android Studio, and integrated with Firebase, the app allows users to register their face and authenticate without the need for traditional passwords. In addition to face recognition, Through Face App features a powerful task management system where users can create, manage, and organize their daily tasks. The app includes a smart calendar view to visualize tasks by date and a search feature to quickly find specific tasks. With modern Material Design UI, smooth Google authentication, and real-time database integration, Through Face App not only simplifies daily task management but also enhances security through biometric login. It is designed for users who want to experience the next level of convenience and safety in mobile apps.",
    image: [
      "https://github.com/Balaji-Rishi/Through-Face-App/blob/main/FaceApp3.jpg?raw=true",
    ],
    tags: [
      "Android Studio", 
      "Java", 
      "Android",
      "Android App",
      "Firebase", 
      "Google Auth", 
      "REST API", 
      "Material Design", 
      "LiveData", 
      "ViewModel", 
      "Push Notifications", 
      "Glide", 
      "XML Layouts", 
      "Git Version Control" 
    ],
    category: "android app",
    github: "https://github.com/Balaji-Rishi/Through-Face-App.git",
    webapp: "https://www.tictoks.in/ThroughFace.apk",
  },

  {
    id: 7,
    title: "V Track App",
    date: "Sep 2022 - May 2025",
    description:
      "V Track App is a powerful Android application designed to help users track and monitor their vehicles in real-time with ease. Developed using Java and Android Studio, the app integrates with GPS tracking technology and Firebase to provide accurate and live vehicle location updates. With V Track App, users can view their vehicle's current position on an interactive map, check route history, and get alerts for movements or unusual activity. The app is built with a clean Material Design interface and offers smooth navigation, making vehicle monitoring simple and efficient. Whether for personal use or fleet management, V Track App enhances security, improves control, and ensures peace of mind by keeping you connected to your vehicle anytime, anywhere.",
    image:
      "https://github.com/Balaji-Rishi/-VTrack/blob/main/vTrack.jpg?raw=true",
    tags: [
      "Android Studio", 
      "Java", 
      "Android",
      "Android App",
      "Firebase", 
      "Google Auth", 
      "REST API", 
      "Material Design", 
      "LiveData", 
      "ViewModel", 
      "Push Notifications", 
      "Glide", 
      "XML Layouts", 
      "Git Version Control" 

    ],
    category: "android app",
    github: "https://github.com/Balaji-Rishi/-VTrack.git",
    webapp: "https://www.tictoks.in/TictoksTrip.apk",
  },

  {
    id: 8,
    title: "Employee App",
    date: "Sep 2022 - May 2025",
    description:
      "Employee App is an all-in-one Android application designed to simplify employee management for businesses of all sizes. Built using Java, Android Studio, and integrated with Firebase, the app allows organizations to manage employee attendance, track working hours, assign tasks, and monitor performance — all from a mobile device. With a user-friendly Material Design interface, employees can easily check in and out, view their schedules, receive task updates, and stay connected with the company. Employers can generate attendance reports, track productivity, and streamline internal communication. Whether for small teams or large enterprises, Employee App helps improve efficiency, reduce paperwork, and digitize workforce management with real-time tracking and notifications.",
    image:
      "https://github.com/Balaji-Rishi/Employee-App/blob/main/Empapp.jpg?raw=true",
    tags: [
      "Java", 
      "Android Studio", 
      "Firebase", 
      "Google Auth", 
      "REST API", 
      "Material Design", 
      "LiveData", 
      "ViewModel", 
      "Push Notifications", 
      "Retrofit", 
      "Glide", 
      "XML Layouts", 
      "Git Version Control"
    ],
    category: "android app",
    github: "https://github.com/Balaji-Rishi/Employee-App.git",
    webapp: "https://www.tictoks.in/TictoksEmp.apk",
  },

];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
